unable to read source [project]/node_modules/.pnpm/zxcvbn@4.4.2/node_modules/zxcvbn/lib/..src/matching.coffee